import { Paper, Table } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailRegistryBody } from "./SystemEmailRegistryBody";
import { SystemEmailRegistryHeader } from "./SystemEmailRegistryHeader";

interface Props {
  entries: SystemEmailRegistryEntry[];
  onPreview: (id: string) => void;
}

export function SystemEmailRegistryContent({ entries, onPreview }: Props) {
  return (
    <Paper withBorder>
      <Table.ScrollContainer minWidth={1100}>
        <Table striped highlightOnHover verticalSpacing="md">
          <SystemEmailRegistryHeader />
          <SystemEmailRegistryBody entries={entries} onPreview={onPreview} />
        </Table>
      </Table.ScrollContainer>
    </Paper>
  );
}
